import { dateWordCard, parseCalendarDate } from 'helper/helper';

/**
 * When a contract is expected to be generated (JBWEB-1138).
 *
 * A contract is no longer created when a temp worker is assigned: it is created
 * when an admin asks for it. Until then the mission can be edited freely, with
 * no amendment. This date is what tells the admin that the waiting is over —
 * before it, generating is a forcing; from it, it is the expected action.
 */

const GENERATION_HOUR = 12;

const atGenerationHour = (date) =>
  new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    GENERATION_HOUR,
    0,
    0,
    0
  );

/**
 * The mission's first day at 12:00 — or the day after it was created, when the
 * mission was created on its start day or later. A contract dated before the
 * mission existed would be announced for a moment already gone.
 */
export const contractGenerationDate = (mission) => {
  const start = mission?.duration?.datestart;
  if (!start) return null;

  const startDay = parseCalendarDate(start);
  if (Number.isNaN(startDay.getTime())) return null;
  const startNoon = atGenerationHour(startDay);

  const created = mission?.createdAt ? new Date(mission.createdAt) : null;
  if (!created || Number.isNaN(created.getTime())) return startNoon;

  const dayAfterCreation = atGenerationHour(created);
  dayAfterCreation.setDate(dayAfterCreation.getDate() + 1);

  return dayAfterCreation > startNoon ? dayAfterCreation : startNoon;
};

/** "17 Janv. 2025 à 12:00" */
export const contractGenerationLabel = (date) => {
  if (!date || Number.isNaN(date.getTime())) return '';
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${dateWordCard(date)} à ${hours}:${minutes}`;
};

/** Whether generating is the expected action rather than a forcing. */
export const isContractGenerationDue = (mission, now = new Date()) => {
  const date = contractGenerationDate(mission);
  // Nothing to wait for when the mission has no start date: an admin who asks
  // is not forcing anything.
  if (!date) return true;
  return now.getTime() >= date.getTime();
};
